import {
  Component,
  EventEmitter,
  Input,
  model,
  OnInit,
  Output,
} from '@angular/core';
import { calculateMaxDate } from '@utils';
import { IconName } from 'nanaykuna-ui-kit/loader';

@Component({
  selector: 'unicon-text-select-field',
  templateUrl: './text-select-field.component.html',
  styleUrl: './text-select-field.component.scss',
})
export class TextSelectFieldComponent implements OnInit {
  @Input() icon: IconName = 'calendar';
  @Input() value?: string | number;
  @Input() placeholder: string = '';
  @Input() dropdown: boolean = false;
  @Output() selected: EventEmitter<string> = new EventEmitter<string>();

  protected today: Date = new Date();
  protected maxDate: Date = calculateMaxDate();
  protected datetime = model<Date | null>(null);

  ngOnInit(): void {}

  protected onSelectedDate(date: Date): void {
    if (date >= this.today && date <= this.maxDate) {
      this.datetime.set(date);
      this.selected.emit(date.toISOString());
    }
  }
}
